import { SVGProps } from 'react';

export function SubmitIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5 1L1.5 10.0588L10.5588 13.9412L14.4412 23L23.5 1Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M10.4375 14.0625L23.5 1" stroke={fill} strokeWidth="1.5" />
    </svg>
  );
}
